import React, { useState } from "react";
import { Grid, Typography, Paper } from "@mui/material";
import SelectYearFromRange from "./SelectYearFromRange";
import TextInput from "./TextInput";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { connect } from "react-redux";
import { currencyFormatter } from "../../../../common/shared";

const SocialSecuritySurvivorBenefits = (props) => {
  const [showEndSurvivorPayments, setShowEndSurvivorPayments] = useState(false);
  const [disableSurvivorEndYear, setDisableSurvivorEndYear] = useState(true);

  const updateShowEndSurvivorPayments = (value) => {
    setShowEndSurvivorPayments(value === "yes");
    props.setHasSocialSecuritySurvivorBenefits(value === "yes");
  };

  const updateEndSurvivorBenefits = (value) => {
    if (value === "yes") {
      props.setSocialSecuritySurvivorBeneifts({
        ...props.socialSecuritySurvivorBenefits,
        survivorBenefitEndYear:
          props.socialSecuritySurvivorBenefits.survivorBenefitStartYear,
      });
      setDisableSurvivorEndYear(false);
      return;
    }

    props.setSocialSecuritySurvivorBeneifts({
      ...props.socialSecuritySurvivorBenefits,
      survivorBenefitEndYear: null,
    });
    setDisableSurvivorEndYear(true);
  };

  const survivorBenefitsStartYearPickListMaximum =
    props.socialSecuritySurvivorBenefits.survivorAgeAtEligibleYear >=
    props.socialSecuritySurvivorBenefits.survivorFullRetirementAge
      ? props.socialSecuritySurvivorBenefits.defaultStartYear
      : props.socialSecuritySurvivorBenefits.survivorFullRetirmenetYear;

  return (
    <Paper elevation={1}>
      <Grid
        className={"social-security-survivor-benefits"}
        direction="column"
        container
        spacing={4}
      >
        <Grid item xs={12}>
          <Typography component={"h1"} variant={"h1"}>
            Social Security Survivor Benefit
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography component={"p"} variant={"p"}>
            Plan Wizard has evaluated that{" "}
            {props.socialSecuritySurvivorBenefits.survivourName} will be
            eligible for Survivor Benefits beginning in the year{" "}
            {props.socialSecuritySurvivorBenefits.survivorBenefitStartYear}.
            Survivor benefits are based on the widow(er)’s age. Survivor
            payments can start at age 60 up to full retirement age.
            Additionally, if widow(er) is receiving Social Security Survivor
            Benefits and will qualify for a retirement benefit that's more than
            their Survivor Benefits, they can switch to their own retirement
            benefit as early as age 62 or as late as age 70.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography component={"p"} variant={"p"}>
            Select start year to view estimated Monthly Survivor Benefit amount.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography component={"p"} variant={"p"}>
            Does {props.socialSecuritySurvivorBenefits.survivourName} want to
            start receiving Survivor Benefits?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <RadioGroup
              aria-labelledby="has-survivors-benefits-radio-buttons-group-label"
              defaultValue="no"
              name="has-survivors-benefits-radio-buttons-group"
            >
              <FormControlLabel
                value="no"
                control={
                  <Radio
                    onChange={(e) =>
                      updateShowEndSurvivorPayments(e.target.value)
                    }
                  />
                }
                label="No, do not add Survivor Benefits to the Plan."
              />
              <FormControlLabel
                value="yes"
                control={
                  <Radio
                    onChange={(e) =>
                      updateShowEndSurvivorPayments(e.target.value)
                    }
                  />
                }
                label="Yes, add Survivor Benefits to the Plan beginning in year:"
              />
            </RadioGroup>

            <SelectYearFromRange
              value={
                props.socialSecuritySurvivorBenefits.survivorBenefitStartYear
              }
              onChange={(e) => {
                props.setSocialSecuritySurvivorBeneifts({
                  ...props.socialSecuritySurvivorBenefits,
                  survivorBenefitStartYear: e.target.value,
                  survivorBenefitEndYear: Math.max(
                    e.target.value,
                    props.socialSecuritySurvivorBenefits.survivorBenefitEndYear
                  ),
                });
              }}
              startYear={props.socialSecuritySurvivorBenefits.defaultStartYear}
              endYear={survivorBenefitsStartYearPickListMaximum}
            />

            <Typography component={"p"} variant={"p"}>
              The estimated{" "}
              {props.socialSecuritySurvivorBenefits
                .planSocialSecuritySurvivorBenefitYearMap[
                props.socialSecuritySurvivorBenefits.survivorBenefitStartYear
              ].sssBenefitFull
                ? "Full"
                : "Reduced"}{" "}
              Monthly Survivor Benefit is{" "}
              {currencyFormatter.format(
                props.socialSecuritySurvivorBenefits
                  .planSocialSecuritySurvivorBenefitYearMap[
                  props.socialSecuritySurvivorBenefits.survivorBenefitStartYear
                ].benefitAmount
              )}
              .
            </Typography>
          </FormControl>
        </Grid>
        {showEndSurvivorPayments &&
          props.socialSecuritySurvivorBenefits.survivorAgeAtEligibleYear <=
            70 && (
            <Grid item xs={12}>
              <Typography component={"p"} variant={"p"}>
                Does {props.socialSecuritySurvivorBenefits.survivourName} want
                to end the Survivor Benefit payment to start their own SSI
                payment in the future?
              </Typography>
            </Grid>
          )}
        {showEndSurvivorPayments &&
          props.socialSecuritySurvivorBenefits.survivorAgeAtEligibleYear <=
            70 && (
            <Grid item xs={12}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="end-survivors-benefits-radio-buttons-group-label"
                  defaultValue="no"
                  name="end-survivors-benefits-radio-buttons-group"
                >
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        onChange={(e) =>
                          updateEndSurvivorBenefits(e.target.value)
                        }
                      />
                    }
                    label="No, do not end Survivor Benefits"
                  />
                  <FormControlLabel
                    value="yes"
                    control={
                      <Radio
                        onChange={(e) =>
                          updateEndSurvivorBenefits(e.target.value)
                        }
                      />
                    }
                    label={`Yes, end Survivor Benefits in year:`}
                  />
                </RadioGroup>
                <SelectYearFromRange
                  readOnly={disableSurvivorEndYear}
                  value={
                    props.socialSecuritySurvivorBenefits.survivorBenefitEndYear
                  }
                  onChange={(e) => {
                    props.setSocialSecuritySurvivorBeneifts({
                      ...props.socialSecuritySurvivorBenefits,
                      survivorBenefitEndYear: e.target.value,
                    });
                  }}
                  startYear={
                    props.socialSecuritySurvivorBenefits
                      .survivorBenefitStartYear
                  }
                  endYear={
                    props.socialSecuritySurvivorBenefits.yearSurvivorTurns70
                  }
                />
              </FormControl>
            </Grid>
          )}
        {showEndSurvivorPayments &&
          props.socialSecuritySurvivorBenefits.survivorAgeAtEligibleYear <=
            70 && (
            <Grid item xs={12}>
              <Typography component={"p"} variant={"p"}>
                and start my estimated Monthly Social Security Income of:
              </Typography>
              <TextInput
                type="number"
                readOnly={disableSurvivorEndYear}
                label=""
                adornment="$"
                helperText="Must be greater than $0"
                value={
                  props.socialSecuritySurvivorBenefits
                    .survivorEstimatedSSIAmount
                }
                onChange={(e) => {
                  props.setSocialSecuritySurvivorBeneifts({
                    ...props.socialSecuritySurvivorBenefits,
                    survivorEstimatedSSIAmount: e.target.value,
                  });
                }}
              />
            </Grid>
          )}
      </Grid>
    </Paper>
  );
};

const mapStateToProps = (state) => {
  return {
    currentClient: state.currentClientReducer,
  };
};

export default connect(mapStateToProps)(SocialSecuritySurvivorBenefits);
